import { Chip } from "@material-tailwind/react";
import React from "react";

function ConferenceStatusTag({ data }) {
  return (
    <div className="flex mb-2">
      {data.exempt && data.receipt?.amount === 0 ? (
        <Chip
          color="indigo"
          variant="ghost"
          value="EXEMPTED. REGISTERED FOR CONFERENCE"
        />
      ) : data.receipt && data.receipt.status === 1 ? (
        <Chip
          color="green"
          variant="ghost"
          value={`PAID, ${data.receipt?.sub_type ?? ""}, ${
            data.transport?.status
              ? data.transport.sub_type + " transport,"
              : ""
          } ${data.creche?.status ? data.creche?.type : ""} `}
        />
      ) : data.receipt && data.receipt.status === 0 ? (
        <Chip
          color="light-blue"
          variant="ghost"
          value={`NOT REGISTERED - MANUAL PAYMENT REQUEST (${data.conf_type}). NOT YET CLEARED.`}
        />
      ) : (
        // : data.receiptStatus === true ? (
        //   <Chip1
        //     color="light-blue"
        //     variant="ghost"
        //     value={`REGISTERED (${data.conf_type}). NOT PAID`}
        //   />
        // )
        <Chip color="amber" variant="ghost" value="NOT REGISTERED" />
      )}
    </div>
  );
}

export default ConferenceStatusTag;
